import { v4 as uuid } from 'uuid';
import { IGizmo, IGizmoData, IGizmoFeatures, IError } from '../../types';

interface ICommonValidationsParams {
  config: IGizmo;
  features: IGizmoFeatures;
  data?: IGizmoData | IGizmoData[];
}

/**
 * Check validations that are common to all gizmos
 *
 * @param {IGizmo} config gizmo's configuration
 * @param {IGizmoFeatures} features dynamic gizmo features
 * @param {IGizmoData | IGizmoData[]} data gizmo's data
 * @returns
 */
function commonValidations({
  config,
  features,
  data,
}: ICommonValidationsParams): IError[] {
  let errors: IError[] = [];

  let message = 'Se requiere una respuesta';
  if (features.required) {
    if (
      data === undefined ||
      (data &&
        !Array.isArray(data) &&
        (data['v'] === undefined || data['v'] === ''))
    ) {
      if (config.ops?.required?.errorMessage) {
        message = config.ops?.required?.errorMessage;
      }

      errors.push({
        fid: uuid(),
        code: 'common.required',
        message,
      });
    } else if (
      config.ops?.search?.rootGizmoFid &&
      data && !Array.isArray(data) && data['sd'] === undefined
    ) {
      errors.push({
        fid: uuid(),
        code: 'common.required',
        message: 'Aún no se ha seleccionado un resultado de búsqueda válido',
      });
    }
  }

  return errors;
}

export default commonValidations;
